<template>
  <custom-dialog
    :title="title"
    width="1280px"
    :visible="visible"
    :append-to-body="true"
    v-on="$listeners"
  >
    <div class="dialog-body">
      <bill-container
        :title="$t('fms_deposit_refund_detail_dialog.yfkzdxx')"
        class="item-title-info"
      >
        <el-row style="padding-top: 16px">
          <el-col :span="8">
            <span class="label">{{ $t('fms_deposit_refund_detail_dialog.shen_qing_ren') }}:</span>
            <span class="value">{{ detail.creator }}</span>
          </el-col>
          <el-col :span="8">
            <span class="label">{{ $t('fms_deposit_refund_detail_dialog.shen_qing_shi_jian') }}:</span>
            <span class="value">{{ momentAmPm($momentLocal(detail.gmtCreate)) }}</span>
          </el-col>
          <!-- 后端没有存该字段，暂时删除 -->
          <!-- <el-col :span="8">
            <span class="label">{{ $t('page__sqrssgs') }}:</span>
            <span class="value">{{ detail }}</span>
          </el-col> -->
          <el-col :span="8">
            <span class="label">{{ $t('fms_deposit_refund_detail_dialog.sqtkfs') }}:</span>
            <span class="value">{{ getDicValue('refund_method', detail.refundMethod) }}</span>
          </el-col>
          <el-col
            :span="8"
            v-if="detail.receivableAccount && detail.refundMethod == 1"
          >
            <span class="label">{{ $t('fms_deposit_refund_detail_dialog.yin_hang_zhang_hu') }}:</span>
            <span class="value">{{ detail.receivableAccount || '-' }} / {{ detail.receivableBank || '-' }}</span>
          </el-col>
          <!-- 和张鹏确认，他说取不到，暂时删除 -->
          <!-- <el-col :span="8">
            <span class="label">{{ $t('page__sqtkms') }}:</span>
            <span class="value">{{ detail.refundDesc }}</span>
          </el-col> -->
        </el-row>
      </bill-container>
      <!-- 应退款押金明细 -->
      <bill-container :title="$t('fms_deposit_refund_detail_dialog.ytkyjmx')">
        <accounts-refund-bill
          ref="orderViewList"
          v-model="orderViewList"
        ></accounts-refund-bill>
      </bill-container>
    </div>
    <div
      class="dialog-footer"
      slot="footer"
    >
      <el-button
        @click="onCancel"
        type="primary"
      >{{ $t('Common.com_close') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import commonDialogMixin from './dialogMixin';
import billContainer from './bill_container';
import accountsRefundBill from './accounts_refund_bill';

export default {
  name: '',
  mixins: [dialogMixins, commonDialogMixin],
  components: {
    accountsRefundBill,
    billContainer,
  },
  data() {
    return {
      detail: {},
      // 应收款账单列表
      orderViewList: [],
      // 结余明细
      partnerBalanceBoList: [],
      // 收款信息
      tradeBoList: [],
      // 银行流水
      tradeSellerBos: [],
      registerMsg: {
        balance: 0,
        deposit: 0,
        billPaymentCode: '',
      },
      firstOrderItem: {},
    };
  },
  mounted() {
    this.orderViewList = this.model.data.billData; // 表格选中行
    this.firstOrderItem = this.orderViewList[0];
    this.getPageInfo(); // 获取收款信息
  },
  computed: {
    title() {
      return this.$t('fms_deposit_refund_detail_dialog.cktksq');
    },
  },
  methods: {
    closeDialog() {
      this.visible = false;
    },
    onCancel() {
      this.closeDialog();
    },
    // 获取信息
    getPageInfo() {
      const firstItem = this.orderViewList[0];
      this.$getJSON(`${apis.DepositRefundApplyDetail}`, {
        billId: firstItem.billId,
      }).then((res) => {
        const data = res.data;
        this.detail = data;
        if (data.billList && data.billList.length) {
          this.orderViewList = data.billList;
        }
      });
    },
    // 删除应收账单信息
    onDelOrderView(index) {
      this.$refs.orderViewList.delRow(index);
    },

    // 参数处理
    getReqData() {
      const useBalance = this.$refs.msgBill.isUseRest();
      return {
        balanceAmount: this.$refs.msgBill.getRest(),
        depositAmount: 0,
        finalPayment: this.$refs.msgBill.getTotal('totalAmount'),
        paymentAmount: this.$refs.orderViewList.getTotal('paymentAmount'),
        billPaymentCode: this.getPaymentCode(this.registerMsg),
        paymentCode: this.getPaymentCode(this.registerMsg),
        billList: this.orderViewList,
        tradeList: this.tradeBoList,
        useBalance,
      };
    },
  },
};
</script>

<style></style>
